import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import getDefaultState from './get-default-state';

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters,
};
